import { useTranslation } from 'react-i18next';

export function UnsupportedAnswerView() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView',
  });

  return (
    <div className="flex min-h-[300px] w-full flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-base-300 bg-base-200/50 p-12">
      <span className="text-sm text-base-content/60">
        {t('unsupportedType')}
      </span>
    </div>
  );
}
